/**
 * The retired `canny`, `depth` and `pose` effects, folded into `control`: `canny.strength` → `control.edges_strength`, `depth.strength`/`floor` → `control.depth_strength`/`depth_floor`, `pose.strength`/`floor` → `control.pose_strength`/`pose_floor`. The old bags are removed. The relocation table only reaches pre-chop flat keys, so a preset written after the chop needs this step.
 *
 * Idempotent by key evidence. A destination already present wins: a preset holding both spellings was written by a client that knew the new one.
 */
const isPlainObject = v => !!v && typeof v === 'object' && !Array.isArray(v)

const MOVES = {
	canny: { strength: 'edges_strength' },
	depth: { strength: 'depth_strength', floor: 'depth_floor' },
	pose: { strength: 'pose_strength', floor: 'pose_floor' },
}

export function controlGroup(settings) {
	if (!isPlainObject(settings)) return settings
	const retired = Object.keys(MOVES).filter(effect => effect in settings)
	if (!retired.length) return settings

	const out = { ...settings }
	let control = null
	for (const effect of retired) {
		const bag = settings[effect]
		delete out[effect]
		if (!isPlainObject(bag)) continue
		for (const [from, to] of Object.entries(MOVES[effect])) {
			if (!(from in bag)) continue
			control ??= isPlainObject(settings.control) ? { ...settings.control } : {}
			if (!(to in control)) control[to] = bag[from]
		}
	}
	if (control) out.control = control
	return out
}

export default controlGroup
